import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
// routes
import { PATH_DASHBOARD } from 'src/routes/paths';
// auth
// components
import { IconButtonAnimate } from 'src/components/animate';
import { useUser } from 'src/hooks/query/userHooks';
import { ChatBubbleLeftIcon } from '@heroicons/react/24/solid';
import { Badge, IconButton, Stack, Tooltip } from '@mui/material';
import { useConvUnreadCount } from 'src/hooks/query/useBandwidthHooks';
import { useCurrentOrgContext } from 'src/contexts/OrgContext';
import { isHighRole, roleHasPermission } from 'src/auth/rbac';
import { useUserRole } from 'src/hooks/useUserRole';
import { Features, orgHasPermission } from 'src/auth/fbac';
import { useOrg } from 'src/hooks/query/orgHooks';

// ----------------------------------------------------------------------

export default function ConversationalTextingPopover() {
  const navigate = useNavigate();
  const { data: unreadCount, refetch: convRefetch } = useConvUnreadCount();
  const { data: currentUser } = useUser();
  const { data: userRole } = useUserRole();
  const { data: org } = useOrg();
  const { orgId } = useCurrentOrgContext();

  useEffect(() => {
    if (orgId) convRefetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  const orgCanText = orgHasPermission(org, [Features.Text]);

  return (
    <>
      {currentUser && roleHasPermission('conversations', userRole) && orgCanText && (
        <Tooltip
          title="Text Conversations"
          arrow
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -8],
                  },
                },
              ],
            },
          }}
        >
          <IconButtonAnimate onClick={() => navigate(PATH_DASHBOARD.conversations.root)}>
            <Badge badgeContent={unreadCount || 0} max={99} color="error">
              <ChatBubbleLeftIcon width={20} height={20} />
            </Badge>
          </IconButtonAnimate>
        </Tooltip>
      )}
      {currentUser && isHighRole(userRole) && !orgCanText && (
        <Tooltip
          title="Texting subscription required"
          arrow
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -8],
                  },
                },
              ],
            },
          }}
        >
          <Stack>
            <IconButton disabled>
              <ChatBubbleLeftIcon width={20} height={20} />
            </IconButton>
          </Stack>
        </Tooltip>
      )}
    </>
  );
}
